import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=5a0b985c&lang=pug&"
var script = {}
import style0 from "./Admin.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports